import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setNid } from '../store/slices/domainOrchestratorPricingCommittee.slice';
import { pathOPCDashboard } from '@pages/OrchestratorPricingCommitteePage/routes/routes.types';

export const useNidNavigation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNidClick = (nid: string) => {
    dispatch(setNid(nid));
    navigate(`/orchestrator-pricing-committee/${pathOPCDashboard}`);
  };

  return { handleNidClick };
};

